import styled from 'styled-components';


export const Container = styled.div`
display: flex;
flex-direction: column;
/* background-color: blue; */
/* min-height: 190vh; */
height: fit-content;
justify-content: center;
/* height: 180vh */
/* overflow: scroll; */
`;